import React from 'react';

class Banner extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    let page_id = this.props.page_id;
    let handleClickBelow = this.props.handleClickBelow;
    let pageData = this.props.pages.pageData[page_id];
    let sectionData = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf : [];

    if(!Object.keys(sectionData).length) return <section className="section" data-hammenu="white" />;
    return (
        <section className="section" data-hammenu="white">
            <div className="ll__inner--hero">
                <figure><img className="fullScreen" src={sectionData.image.url} alt={sectionData.image.alt} title={sectionData.image.title} /></figure>
                <div className="bottom-content">
                    <div className="main-container">
                        <h1 className="title-xl">{pageData.title.rendered}</h1>
                    </div>
                </div>
                <a href="javascript:" id="btn--scroll-down"  onClick={handleClickBelow}></a>
            </div>
        </section>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Practice/Banner.js